<button type="button" class="workflow-condition-preview" (click)="edit()"
        [id]="'workflow-condition-edit-' + stageIndex" [attr.aria-label]="_('Bedingungen bearbeiten') + ': ' + stageName">
  <i class="fa" [ngClass]="expression ? 'fa-code-fork' : 'fa-plus'" aria-hidden="true"></i>
  <span class="workflow-condition-text">
    <ng-container *ngIf="expression; else empty">
      <strong>{{_('Nur wenn')}}:</strong>
      <app-workflow-condition-summary [root]="group" [variables]="variables"></app-workflow-condition-summary>
    </ng-container>
    <ng-template #empty>{{_('Bedingung hinzufügen')}} <span class="workflow-condition-hint">{{_('Sonst wird dieser Schritt immer ausgeführt.')}}</span></ng-template>
  </span>
  <i class="fa fa-pencil" aria-hidden="true"></i>
</button>
<p *ngIf="warning" class="workflow-condition-warning" role="status">{{_(warning)}}</p>
